import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { controlAccessPopUp } from '@app/modules/ui-notification/ControlAccessDialog/controlaccess.component';
import { Licence } from '@core/auth/guards/license.guard';
import { UserService } from '@core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { BehaviorSubject, Observable, catchError, filter, finalize, map, switchMap, take, tap, throwError } from 'rxjs';

const processCount: BehaviorSubject<number> = new BehaviorSubject<number>(0)
export const isLoading: Observable<boolean> = processCount.pipe(map(c => c > 0))


function addProcessing(): void {
    processCount.next(processCount.value + 1)
}

function popProcessing(): void {
    if (processCount.value < 0)
        processCount.next(0)
    else {
        processCount.next(processCount.value - 1)
    }
}

let accessPopupShown = false

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const loadingInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const _userService = inject(UserService);
    const dialog = inject(MatDialog);

    addProcessing();
    return next(req).pipe(
        //filter((event) => event instanceof HttpResponse),
        catchError((res) => {
            if (!(res instanceof HttpErrorResponse)) {
                return throwError(() => res)
            }
            console.warn('Failure from ' + req.url, res.status);
            const httpErr = res as HttpErrorResponse
            if (res.status == 403 && httpErr?.error?.message != "Email not verified" && !accessPopupShown) {
                return _userService.user$.pipe(take(1), tap({
                    next: u => {
                        if (!accessPopupShown) {
                            accessPopupShown = true;
                            const neededAccountLicence: string = u.accessLevel == Licence.Freemium ? "Premium" : "Premium +"
                            const dialogRef = controlAccessPopUp(
                                dialog,
                                `Subscribe to a <span class="text-red-500">${neededAccountLicence}</span> account to unlock this feature`,
                                'Subscribe to ' + neededAccountLicence
                            );
                            dialogRef.afterClosed().subscribe(() => {
                                accessPopupShown = false; // when the popup is closed
                            });
                            console.log("User ", u)
                        }
                    }
                }), switchMap(_ => throwError(() => res)))
            }
            return throwError(() => res)
        }),
        finalize(() => {
            popProcessing();
        }),
    )
};
